import React from "react";
import CommonImageSlider from "./comandata";
import CallandRegisterComponent from "./Callbutton";
import { homeImages, ShorttermCourse, studentsRanks } from "./data";
import CrashCoursesPage from "./subcomponents/CrashCoursesPage";
import CommonImageSliderRanks from "./CommonsliderRanks";
import { CommonAboutHeader } from "./CommonAboutHeader";

const Shortterm = () => {
  return (
    <div>
       {/* <h1 className="text-xl md:text-4xl font-bold text-[#20b2aa] text-center">
         Best EAMCET (EAPCET), IIT-JEE, NEET & BITSAT Short Term Coaching (Crash Course) in Hyderabad
        </h1> */}
      {/* <CallandRegisterComponent /> 
      <CommonAboutHeader images={ShorttermCourse}/>*/}
       {/* <div className="mb-10 mt-8 me-2 ms-2">
<CallandRegisterComponent />
</div> */}
<section>
<CrashCoursesPage />

</section>

 
    </div>
  );
};

export default Shortterm;
